"use client";

import { m, useScroll, useSpring } from "motion/react";

/**
 * Thin progress bar pinned to the very top of the viewport that fills
 * left-to-right as the user scrolls the page. Sits above everything
 * (z-index high) but is `aria-hidden` and `pointer-events-none` so it
 * doesn't interfere with any actual UI.
 *
 * Spring-smoothed off the raw scroll progress so it doesn't twitch on
 * every wheel tick.
 *
 * `scaleX` with `transform-origin: left` is the canonical Motion
 * scroll-progress pattern — much cheaper than animating `width`
 * because it stays on the compositor.
 */
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 180,
    damping: 30,
    mass: 0.3,
    restDelta: 0.001,
  });

  return (
    <m.div
      aria-hidden
      className="bg-hop pointer-events-none fixed top-0 right-0 left-0 z-[60] h-[3px] origin-left"
      style={{ scaleX }}
    />
  );
}
